module.exports = __webpack_public_path__ + "img/style4_f787a92ed.png";